module.exports = __webpack_public_path__ + "static/img/7.f238a43.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/carts/7.png
// module id = KdWq
// module chunks = 16